import { Stack, Typography, Collapse } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { ReactNode } from "react";

interface CollapsibleSectionProps {
    title: string;
    icon: ReactNode;
    isOpen: boolean;
    onToggle: () => void;
    children: ReactNode;
}

export function CollapsibleSection({
    title,
    icon,
    isOpen,
    onToggle,
    children,
}: CollapsibleSectionProps) {
    return (
        <>
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          padding: "10px",
          marginBottom: "10px",
          width: "100%",
          cursor: "pointer",
          transition: "background-color 0.3s ease",
          backgroundColor: isOpen ? "rgba(25, 118, 210, 0.08)" : "transparent",
          "&:hover": {
            backgroundColor: isOpen 
              ? "rgba(25, 118, 210, 0.12)" 
              : "rgba(0, 0, 0, 0.05)",
          },
        }}
        onClick={onToggle}
      >
                {icon}
                <Typography
                    variant="body1"
                    color="neutral1000.main"
                    align="center"
                    width="100%"
                    fontWeight={500}
                >
                    {title}
                </Typography>
                <ExpandMore
                    sx={{
                        fontSize: "24px",
                        color: "primary.main",
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                    }}
                />
            </Stack>
            <Collapse in={isOpen} timeout={300}>
                <Stack
                    sx={{
                        borderBottom: "2px solid primary.main",
                        paddingBottom: "10px",
                        marginBottom: "10px",
                    }}
                    spacing={2}
                >
                    {children}
                </Stack>
            </Collapse>
        </>
    );
}

